import React from "react";
import classes from "./Category.module.css";

const category = (props) => {
  const customClassName = props.name.replace("-", "");
  const buttonClasses = [classes.Category, classes[customClassName]];
  if (props.notPurchased) {
    buttonClasses.push(classes.NotPurchased);
  }

  const name = props.name.charAt(0).toUpperCase() + props.name.slice(1);
  if (props.active) {
    buttonClasses.push(classes.Active);
  }

  const style = {
    backgroundImage: "url(" + props.image + ")",
  };

  return (
    <button
      className={buttonClasses.join(" ")}
      style={style}
      onClick={props.clicked}
    >
      <div></div>
      <span>{name}</span>
    </button>
  );
};

export default category;
